import React, { useState, useEffect, useRef } from 'react';

import '../css/Popup.css';

interface PopupProps {
    onClose: () => void;
}

const Popup: React.FC<PopupProps> = ({ onClose }) => {
    return (
        <div className="popup">
            <div className="popup-content">
                <button className="close-btn" onClick={onClose}>
                    X
                </button>
                <img src={`${process.env.PUBLIC_URL}/aegis_banner.png`} alt="Popup Image" className="popup-image" />
            </div>
        </div>
    );
};

export default Popup;
